export default function Hero() {
  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/398e8603705ecd94230ee90f8a7ee726.png"
          alt="Love yourself beauty by Meltem - Salon"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Entdecke deine natürliche Schönheit
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 font-light">
          Professionelle Kosmetikbehandlungen in entspannter Atmosphäre
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://buchung.treatwell.de/ort/445747/menue/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-rose-400 to-rose-300 text-white px-8 py-4 rounded-full text-base font-medium hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-block"
          >
            Jetzt Termin buchen
          </a>
          <button
            onClick={() => {
              const element = document.getElementById('services');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-full text-base font-medium hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Unsere Leistungen
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
